<template>
  <div class="remerciements-container col-sm-12">
    <div
      style="display: table-row; height: 97px;"
      v-if="isPaiementEnSucces || isPaiementEnEchec"
    >
      <b-navbar toggleable="lg" type="dark" variant="info">
        <b-navbar-brand class="col-md-2"
          ><a href="http://www.ffbb.com" target="_blank"
            ><img src="@/assets/ffbb_hoz_blanc.png" class="nav-logo"
          /></a>
        </b-navbar-brand>
      </b-navbar>
    </div>

    <div class="remerciements">
      <div class="row">
        <img class="bell-img ml-3 mr-3 mt-1" src="@/assets/bell.png" />
        <p class="remerciements-text-bold">
          {{ "remerciements_merci" | translate("fr") }}
        </p>
      </div>
      <p
        v-if="isPaiementEnEchec"
        class="remerciements-text-normal mt-4"
        style="color: rgb(220, 53, 69)"
      >
        {{ "remerciements_echec_paiement_1" | translate("fr") }}
        <a
          style="color: rgb(220, 53, 69); font-weight: bold; text-decoration: underline;"
          v-bind:href="this.pageAccueil"
          >Je m'engage
        </a>
        {{ "remerciements_echec_paiement_2" | translate("fr") }}
      </p>
      <p v-if="isPaiementEnSucces" class="remerciements-text-normal mt-4">
        {{ "remerciements_succes_paiement" | translate("fr") }}
      </p>
      <p class="remerciements-text-normal mt-4">
        {{ "remerciements_text_1" | translate("fr") }}
      </p>
      <p class="remerciements-text-normal mt-4">
        {{ "remerciements_text_2" | translate("fr") }}
      </p>
      <p class="remerciements-text-normal mt-4 mb-4">
        {{ "remerciements_text_3" | translate("fr") }}
      </p>

      <video-embed
        css="embed-responsive-16by9"
        src="https://www.youtube.com/watch?v=kFXT5BlA1mQ"
      ></video-embed>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mt-3"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import translations from "@/Translations.js";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";

export default {
  props: {
    token: undefined,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      token_out: undefined,
      pageAccueil: undefined,
      erreurGlobale: null // valorisée dans traitementErreursServeur
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  methods: {
    postValidationPaiement(checkoutIntentId, isReconnected) {
      var that = this;

      preinscriptionAppelsServeur
        .postValidationPaiement(that.token_out, checkoutIntentId)
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          argsArray.push(checkoutIntentId);
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.postValidationPaiement,
            argsArray
          );
        });
    }
  },
  computed: {
    isPaiementEnEchec() {
      return (
        this.$route.fullPath.indexOf("checkoutIntentId") > -1 &&
        this.$route.fullPath.indexOf("succeeded") === -1
      );
    },
    isPaiementEnSucces() {
      return (
        this.$route.fullPath.indexOf("checkoutIntentId") > -1 &&
        this.$route.fullPath.indexOf("succeeded") > -1
      );
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
    if (
      this.$route.fullPath.indexOf("checkoutIntentId") > -1 &&
      this.$route.fullPath.indexOf("succeeded") === -1
    ) {
      let urlPageAccueil = window.location.href;
      this.pageAccueil = urlPageAccueil.substr(
        0,
        urlPageAccueil.indexOf("&checkoutIntentId")
      );
      //  au bout de 10s rediriger automatiquement vers la page d'accueil
      setTimeout(() => (window.location.href = this.pageAccueil), 10000);
    }
  },
  mounted() {
    if (
      this.$route.fullPath.indexOf("checkoutIntentId") > -1 &&
      this.$route.fullPath.indexOf("succeeded") > -1
    ) {
      let url = decodeURIComponent(window.location.search);
      url = url.replace("?checkoutIntentId", "&checkoutIntentId");
      const urlParams = new URLSearchParams(url);
      let checkoutIntentId = urlParams.get("checkoutIntentId");
      this.postValidationPaiement(checkoutIntentId, false /*isReconnected*/);
    }
  }
};
</script>

<style scoped>
.remerciements-container {
  display: table;
  background-color: #ffffff;
  min-height: 200px;
  height: 100%;
  padding: 0;
}

.remerciements-text-bold {
  font-family: Lato;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.83;
  letter-spacing: normal;
  text-align: justify;
  color: #000000;
}

.remerciements-text-normal {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: justify;
  color: #000000;
}

.bell-img {
  width: 22px;
  height: 22px;
}

.bg-info {
  background-color: #3e5987 !important;
  height: 100%;
  min-height: 97px;
}

.navbar-brand {
  cursor: default;
}

.nav-logo {
  width: 128px;
  height: 51px;
  cursor: pointer;
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .remerciements {
    padding: 5rem 10rem;
    width: 100%;
    display: table-cell;
    vertical-align: middle;
  }

  .navbar-brand {
    text-align: left;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .remerciements {
    margin: 3rem 3rem;
  }

  .nav-logo {
    width: 100px;
    height: 40px;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .remerciements {
    margin: 50px 15px;
  }

  .remerciements-text-normal {
    font-size: 13px;
  }

  .remerciements-text-bold {
    font-size: 25px;
  }

  .bell-img {
    width: 20px;
    height: 20px;
  }

  .nav-logo {
    width: 100px;
    height: 40px;
  }
}
</style>
